/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Pure_Calf_WakeInputs */

const en_deep_pure_calf_wake = /** @type {(inputs: Deep_Pure_Calf_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports`)
};

const de_deep_pure_calf_wake = /** @type {(inputs: Deep_Pure_Calf_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe`)
};

/**
* | output |
* | --- |
* | "Imports" |
*
* @param {Deep_Pure_Calf_WakeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_pure_calf_wake = /** @type {((inputs?: Deep_Pure_Calf_WakeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Pure_Calf_WakeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_pure_calf_wake(inputs)
	return de_deep_pure_calf_wake(inputs)
});